<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="md-grey-page portal-page">
		<div class="page-banner"></div>
		<!-- Settings -->
		<section class="portal-page--settings container container-shadow">
			<div class="portal-page__image-title">
				<img src="/static/img/rightmove-logo.png">
			</div>

			<!-- Confirm that live properties are on BA -->
			<div class="" v-if="stage === stages.CONFIRM">
				<p>Please confirm that you have uploaded all your live properties into BestAgent before activating their portal.</p>
				<a @click="stage = stages.AUTO" class="mdc-button mdc-button--raised portal-page__btn">Yes, I have uploaded all my live properties</a>
				<a @click.prevent="$router.push('/settings/portals')" class="mdc-button mdc-button--stroked portal-page__btn">No, I haven't uploaded all my live properties</a>
			</div>

			<!-- Choose branch IDs -->
			<div class="" v-if="stage === stages.AUTO || stage === stages.MANUAL">
					<div class="portal-page__searching-branches" v-if="!foundBranches">Searching your branch ID on Rightmove...</div>

					<nav v-if="foundBranches" class="portal-page__tab-bar mdc-layout-grid mdc-layout-grid__inner">
						<a href="#" class="portal-page__tab mdc-layout-grid__cell cell-6-xs" @click="branchInputMethod = stages.AUTO; stage = stages.AUTO">Choose your branch ID</a>
						<a href="#" class="portal-page__tab mdc-layout-grid__cell cell-6-xs" @click="branchInputMethod = stages.MANUAL; stage = stages.MANUAL">Enter your branch ID manually</a>
						<span class="portal-page__tab-indicator mdc-tab-bar__indicator" :class="{'portal-page__tab-indicator--manually': branchInputMethod == stages.MANUAL}"></span>
					</nav>

					<!-- Branch ID -->
					<div class="" v-if="foundBranches">
						<!-- Auto -->
						<div class="portal-page__branch-finder" v-if="branchInputMethod === stages.AUTO">
							<div v-if="branches.length === 0">
								<p>Sorry, no branches were found on rightmove with your company name.</p>
								<p><a href="#">I don't have a branch ID</a></p>
								<p><a @click="branchInputMethod = stages.MANUAL; stage = stages.MANUAL">I will enter my branch IDs manually</a></p>
							</div>
							<div v-if="branches.length > 0" class="portal-page__branches-list">
								<div class="portal-page__branches-text">
									<p class="text-center">We found these branches on rightmove</p>
									<p>Please select your Sales and Lettings branches IDs below:</p>
								</div>
								<div class="portal-page__branch mdc-layout-grid" v-for="branch in branches">
									<div class="mdc-layout-grid__inner">
										<!-- Branch ID -->
										<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-8-desktop center-vertical-wrapper"><span class="center-vertical-left">ID:&nbsp; {{branch.branchId}}</span></div>
										<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-4-desktop portal-page__branch__lettings center-vertical-wrapper"><a class="mdc-button mdc-button--stroked center-vertical" :class="{'portal-page__branch--selected': branchIdLettings == branch.branchId}" @click="branchIdLettings = branch.branchId">Lettings</a></div>
										<!-- Branch name -->
										<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-8-desktop center-vertical-wrapper"><span class="center-vertical-left">{{branch.title}} - {{branch.type}}</span></div>
										<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-4-desktop portal-page__branch__sales center-vertical-wrapper"><a class="mdc-button mdc-button--stroked center-vertical" :class="{'portal-page__branch--selected': branchIdSales == branch.branchId}" @click="branchIdSales = branch.branchId">Sales</a></div>
									</div>
								</div>
							</div>
						</div>

						<!-- Manual -->
						<div class="portal-page__input" v-if="branchInputMethod === stages.MANUAL">
							<input-with-clear v-model="branchIdLettings" name="branchIdLettings" :placeholder="'Lettings Branch ID'" :inputType="'number'"></input-with-clear>
							<input-with-clear v-model="branchIdSales" name="branchIdSales" :placeholder="'Sales Branch ID'" :inputType="'number'"></input-with-clear>
						</div>
					</div>

					<!-- Toggle between PCM and PW -->
					<!-- <p class="portal-page__text">Lettings price displayed as:</p> -->

					<!-- Per calendar month -->
					<!-- <div class="lettings-price">
						<input type="radio" id="pcm" name="lettingsPrice" class="lettings-price__radio" value="1" v-model="lettingsPrice">
						<label for="pcm">PCM</label>
					</div> -->

					<!-- Per week -->
					<!-- <div class="lettings-price">
						<input type="radio" id="pw" name="lettingsPrice" class="lettings-price__radio" value="2" v-model="lettingsPrice">
						<label for="pw">PW</label>
					</div> -->

					<!-- <p class="portal-page__text--small">Per {{ lettingsPrice === '1' ?  'Calendar Month' : 'Week' }}</p> -->

					<!-- Activate / deactivate button -->
					<button class="mdc-button mdc-button--raised portal-page__btn" :disabled="branchIdSales === '' && branchIdLettings === ''" @click.prevent="updateEmailContent">Next</button>

					<!-- Back button -->
					<a href="#" class="black-link portal-page__btn portal-page__btn--back" @click.prevent="stage = stages.CONFIRM">&lt; Back</a>
			</div>

		<!-- Email stage  -->
		<div class="portal-page__email" v-if="stage === stages.EMAIL">
			<p>Please click the button to email rightmove or copy &amp; paste the text below</p>
			<p><a href="#" class="mdc-button mdc-button--raised portal-page__btn" @click="sendEmail">Email Portal</a></p>
			<textarea v-model="emailContent" readonly class="portal-page__email-box" onclick="this.focus(); this.select();"></textarea>
			<a @click.prevent="$router.push('/settings/portals')" class="mdc-button mdc-button--raised portal-page__btn">Finish</a>
			<a href="#" class="black-link portal-page__btn portal-page__btn--bac" @click.prevent="stage = stages.AUTO">&lt; Back</a>
		</div>

		<!-- Send email -->
		<!-- <section class="container-white" v-if="stage === stages.SEND_EMAIL">
			<h4 class="portal-page__title">Portal now active</h4>
			<p>You're now sending data to your portal.</p>
			<p class="portal-page__last-paragraph">Send them an email to confirm you're now sending your data from Best Agent</p>
			<a class="mdc-button mdc-button--raised portal-page__btn" @click.prevent="sendEmail">Email portal</a>
		</section> -->

		<!-- Email sent -->
		<!-- <section class="container-white" v-if="stage === stages.EMAIL_SENT">
			<h4 class="portal-page__title">Great!</h4>
			<p class="portal-page__last-paragraph">Now you have emailed them, you're all setup</p>
			<div class="mdc-button mdc-button--raised portal-page__btn" @click="$router.push('/settings/portals');">Ok</div>
		</section> -->
		</section>
	</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import InputWithClear from '../components/InputWithClear.vue';

export default {
	data: function() {
		return {
			lettingsPrice: '1',
			foundBranches: false,
			branches: [],
			stages: {
				CONFIRM: 0,
				AUTO: 1,
				MANUAL: 2,
				EMAIL: 3
			},
			stage: 0,
			branchInputMethod: 1,
			branchIdSales: '',
			branchIdLettings: '',
			emailContent: ''
		}
	},
	components: {
		'input-with-clear': InputWithClear
	},
	created: async function() {
		// Search Branches IDs
		this.branches = await api({endpoint: this.config.services.portals, path: '/rm/find-branches', method: 'GET'});
		this.foundBranches = true;
	},
	methods: {
		updateEmailContent: function() {
			var branchIds = '';
			var branchIdsText = '';
			if(this.branchIdSales != '') {
				branchIds += this.branchIdSales;
				branchIdsText += 'Sales';
			}
			if(this.branchIdLettings != '') {
				if(branchIds !== '') {
					branchIds += ' and ';
					branchIdsText += ' and ';
				}
				branchIds += this.branchIdLettings;
				branchIdsText += 'Lettings';
			}
			this.emailContent = "Hello Rightmove,\n\n" + this.$store.getters.companyName + " have just activated a new property feed from BestAgent to your portal, using the Branch IDs " + branchIds + ".\n\nPlease accept this email as confirmation that with immediate effect we would now like you to take our " + branchIdsText + " property feed from BestAgent, and no other source.\n\nKind regards,\n\n" + this.$store.getters.companyName;
			this.saveInfo();
			this.stage = this.stages.EMAIL;
		},
		saveInfo: async function() {
			var postData = {
				active: true,
				branchIdLettings: this.branchIdLettings,
				branchIdSales: this.branchIdSales
			};

			var result = await api({endpoint: this.config.services.portals, path: '/rm', method: 'PUT', body: postData});
		},
		sendEmail: function() {
			var subject = "Notification of new data feed provider";
			var body = this.emailContent;
			var mailLink = "mailto:adfsupport@rightmove.co.uk?cc=support@bestagent.online&subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);
			window.open(mailLink, "_self");
			this.$router.push('/settings/portals');
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Settings-Portals-Rightmove.vue